// extracted by mini-css-extract-plugin
export default {"uploadPhoto":"GalleryPanel_uploadPhoto__jjbB4"};